/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-underscore-dangle */
import { DataGrid } from '@mui/x-data-grid';
import { withTheme } from '@emotion/react';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { TABLE_HEADER_FONT_COLOR } from 'modules/common/constants/style';
import { selectHotelGroupDropdownList } from '../../selectors';

const columnVisibilityModel = {
  id: false,
};
//
const columns = [
  {
    field: 'id',
    headerName: 'ID',
    headerClassName: 'super-app-theme--header',
    flex: 1,
  },
  {
    field: 'name',
    headerName: 'Name',
    headerClassName: 'super-app-theme--header',
    flex: 1,
  },
  {
    field: 'hotels',
    headerName: 'Hotels',
    headerClassName: 'super-app-theme--header',
    flex: 1,
    sortable: false,
  },
  {
    field: 'query',
    headerName: 'Query',
    headerClassName: 'super-app-theme--header',
    flex: 1,
    sortable: false,
  },
];
//
const HotelSetTableView = ({ setIsEditable, setSelectedHotelName }) => {
  const hotels = useSelector(selectHotelGroupDropdownList);
  //
  const [filteredHotels, setFilteredHotels] = useState([]);
  //
  useEffect(() => {
    const formattedHotels = hotels?.map((hotel) => ({
      id: hotel?.id,
      name: hotel?.label,
      hotels: hotel?.hotels?.map((filter) => filter?.label),
      query: hotel?.query,
    }));
    setFilteredHotels(formattedHotels);
  }, [hotels]);
  //
  const onSelectedRowChange = (ids) => {
    if (ids?.length) {
      setSelectedHotelName(ids[0]);
      setIsEditable(true);
    }
  };
  //
  return (
    <div style={{ height: 700, flex: 1 }}>
      <DataGrid
        sx={{
          '& .super-app-theme--header': {
            backgroundColor: 'white',
            color: TABLE_HEADER_FONT_COLOR,
          },
          '& .MuiDataGrid-main': {
            backgroundColor: 'white',
          },
          '& .MuiDataGrid-footerContainer': {
            backgroundColor: 'white',
          },
          '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
          '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
          '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
        }}
        columnVisibilityModel={columnVisibilityModel}
        getRowHeight={() => 'auto'}
        rows={filteredHotels || []}
        columns={columns}
        onSelectionModelChange={onSelectedRowChange}
      />
    </div>
  );
};
//
export default withTheme(HotelSetTableView);
